import {
  BillingPeriodType,
  humanizeBillingPeriodType,
} from '../../constants/billingPeriodType';

export const getHumanizeBillingPeriodType = (billingPeriodType: BillingPeriodType) => {
  return humanizeBillingPeriodType[billingPeriodType] ?? billingPeriodType;
};
